import { create } from "zustand";

type UploadProgressState = {
  progress: Record<string, number>; // uploadId → 0-100
  setProgress: (uploadId: string, value: number) => void;
  clearProgress: (uploadId: string) => void;
};

export const useUploadProgressState = create<UploadProgressState>()((set) => ({
  progress: {},
  setProgress(uploadId, value) {
    set((state) => ({
      progress: {
        ...state.progress,
        [uploadId]: Math.max(0, Math.min(100, Math.round(value))),
      },
    }));
  },
  clearProgress(uploadId) {
    set((state) => {
      const next = { ...state.progress };
      delete next[uploadId];
      return { progress: next };
    });
  },
}));
